/* eslint-disable import/prefer-default-export */
import { useMutation, useQuery, keepPreviousData } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import { handleErrorNotification } from 'Common/utils';
import { GiftcardReportTableParams } from 'utils/apiClient/services/reports/types';
import { useApiClient } from 'utils/apiClient';

export const useCreateGiftCardReport = () => {
  const apiClient = useApiClient();
  const intl = useIntl();
  return useMutation({
    mutationFn: (type: string) =>
      apiClient.Reports.createGiftcardReport(type, intl.locale),
    onError: (error) => {
      handleErrorNotification({
        error,
        lang: intl.locale.toLowerCase(),
      });
    },
  });
};

export const useGiftcardReport = ({
  tableParams,
  searchQuery,
  enabled,
}: {
  tableParams: GiftcardReportTableParams;
  searchQuery: string | null;
  enabled: boolean;
}) => {
  const apiClient = useApiClient();
  return useQuery({
    queryKey: ['reports', 'giftcards', tableParams],
    queryFn: () =>
      apiClient.Reports.loadGiftcardsReport(tableParams, searchQuery),
    staleTime: 1500,
    refetchOnWindowFocus: false,
    enabled,
  });
};

export const useTaxes = ({ enabled }: { enabled: boolean }) => {
  const apiClient = useApiClient();
  return useQuery({
    queryKey: ['taxes'],
    queryFn: apiClient.Reports.loadTaxes,
    staleTime: 1500,
    enabled,
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
  });
};
